export default __webpack_public_path__ + "static/media/thumbnail.5906aca2.png";